import React from 'react';
import { Box, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';

interface WizardSidebarProps {
  currentStep: number;
  onStepChange: (step: number) => void;
}

const steps = [
  { id: 1, title: 'Basic Information', description: 'Personal details & contact info' },
  { id: 2, title: 'Spouse Information', description: 'Spouse details if married' },
  { id: 3, title: 'Dependents', description: 'Children & other dependents' },
  { id: 4, title: 'Income Sources', description: 'Employment & other income' },
  { id: 5, title: 'Deductions & Credits', description: 'Tax deductions & credits' },
  { id: 6, title: 'Business & Rental', description: 'Business or rental income' },
  { id: 7, title: 'Prior Tax Info', description: 'Previous year tax information' },
  { id: 8, title: 'Document Upload', description: 'Upload tax documents' },
  { id: 9, title: 'Review & Submit', description: 'Final review & submission' }
];

const WizardSidebar: React.FC<WizardSidebarProps> = ({ currentStep, onStepChange }) => {
  return (
    <Box
      sx={{
        width: 280,
        background: '#f8f9fa',
        borderRight: '1px solid #e9ecef',
        padding: 3
      }}
    >
      <List>
        {steps.map((step) => (
          <ListItem
            key={step.id}
            button
            onClick={() => onStepChange(step.id)}
            sx={{
              borderRadius: 1,
              mb: 1,
              background: currentStep === step.id ? 'rgba(102, 126, 234, 0.1)' : 'transparent',
              '&:hover': {
                background: 'rgba(102, 126, 234, 0.05)'
              }
            }}
          >
            <ListItemIcon>
              {currentStep > step.id ? (
                <CheckCircle color="primary" />
              ) : (
                <RadioButtonUnchecked color={currentStep === step.id ? 'primary' : 'disabled'} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={step.title}
              secondary={step.description}
              primaryTypographyProps={{
                color: currentStep === step.id ? 'primary' : 'text.primary',
                fontWeight: currentStep === step.id ? 600 : 400
              }}
              secondaryTypographyProps={{
                fontSize: '0.75rem',
                color: currentStep === step.id ? 'text.secondary' : 'text.disabled'
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default WizardSidebar; 